<template>
  <section class="step-btm-container">
    <a-row type="flex" justify="start" align="middle" :gutter="16">
      <a-col :span="6" flex="100px">
        <a-button
          type="link"
          :size="uiSize"
          block
          @click="prevStep"
          class="step-btm-back-btn"
        >
          <IconBack />
          {{ $t("Back") }}
        </a-button>
      </a-col>
      <a-col :span="6" flex="auto" :offset="6">
        <a-button
          class="step-btm-next-btn"
          type="primary"
          block
          :size="uiSize"
          :disabled="!passed"
          :loading="loading"
          @click="submitForm"
        >
          {{ $t("Save and continue") }}
        </a-button>
      </a-col>
    </a-row>

    <a-modal
      title=""
      :visible="modal2Visible"
      centered
      :okText="$t('Yes,submit')"
      :cancelText="$t('Cancel')"
      :getContainer="() => $root.$el"
      @ok="confirm"
      @cancel="modal2Visible = false"
    >
      <h5>{{ $t("dialog_context") }}</h5>
    </a-modal>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  Divider,
  Checkbox,
  Button,
  Row,
  Col,
  Modal,
  Icon
} from "ant-design-vue";
import IconBack from "@/components/icon-back.svg";
import { doSubmit } from "@/api/kyc";
import { displayErrors } from "@/utils";

export default {
  name: "BtmStepNavIndividual",
  data() {
    return {
      modal2Visible: false
    };
  },
  props: {
    passed: [String, Boolean],
    loading: [Boolean]
  },
  components: {
    [Divider.name]: Divider,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Modal.name]: Modal,
    [Icon.name]: Icon,
    IconBack
  },
  computed: {
    ...mapState("KYC", ["currentStep4Individual", "kycStepLists4Individual"]),
    ...mapState({
      uiSize: state => state.clientInfo.uiSize
    })
  },
  methods: {
    ...mapActions("KYC", ["changeCurrentStep4Individual"]),
    prevStep() {
      if (this.currentStep4Individual == 0) {
        this.$router.back();
        return;
      } else {
        this.changeCurrentStep4Individual(this.currentStep4Individual - 1);
      }
    },
    nextStep(res) {
      if (!res) {
        return;
      } else if (
        this.currentStep4Individual ==
        Object.keys(this.kycStepLists4Individual).length - 1
      ) {
        this.modal2Visible = true;
        return;
      } else {
        this.changeCurrentStep4Individual(this.currentStep4Individual + 1);
      }
    },
    submitForm() {
      this.$emit("submitForm", this.nextStep);
    },
    async confirm() {
      try {
        await doSubmit();
        this.$router.push({
          ...this.$route,
          query: { ...this.$route.query, state: "100" }
        });
        this.modal2Visible = false;
      } catch (err) {
        displayErrors(err);
      }
    }
  }
};
</script>

<style scoped></style>
